import { atom } from "recoil";
export const crmActionCheckListAtom = atom({
  key: "crm-action-checklist",
  default: [],
});
